// Dependencies
import styled from 'styled-components';

// Styles
import { hoverCapable } from '../../../../styles/hover';

// Types
import { ContainerProps, ListItemProps } from './types';

export const DropDownListContainer = styled.div`
  z-index: 999;
  position: relative;
`;

// placement controla si el panel abre hacia abajo (default) o hacia arriba.
// El DropDownListContainer padre tiene altura 0 (sólo envuelve al list absolute),
// por lo que para 'top' usamos bottom: 4rem + spacing (altura del DropDownHeader)
// para que el panel quede ENCIMA del trigger sin pisarlo.
export const List = styled.ul<ContainerProps>`
  position: absolute;
  border-radius: 0.5rem;
  ${({ placement, theme }) =>
    placement === 'top'
      ? `bottom: calc(4rem + ${theme.spacing.xxxs});`
      : `top: ${theme.spacing.xxxs};`}
  color: ${({ theme }) => theme.colors.greyVeryDark};
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.dropdown};
  min-width: 100%;
  width: auto;
  max-height: 35rem;
  overflow: auto;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    max-height: 18rem;
  }
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    max-height: 17rem;
  }
`;

export const ListItem = styled.li<ListItemProps>`
  display: flex;
  align-items: center;
  list-style: none;
  font-size: ${({ theme }) => theme.fontSize.S};
  padding: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${(props) =>
    props.isActive &&
    `
      background-color: ${props.theme.colors.backgroundLila}; /* CAMBIO: Color lila ROIS para seleccionado */
      font-weight: ${props.theme.fontWeight.medium};
    `};
  /* Solo con puntero fino: en táctil el :hover se quedaría pegado tras el
     toque y sería indistinguible de la opción seleccionada (ver styles/hover.ts). */
  ${hoverCapable} {
    &:hover {
      background-color: ${({ theme }) =>
        theme.colors.backgroundLila}; /* CAMBIO: Color lila ROIS para hover */
      font-weight: ${({ theme }) => theme.fontWeight.medium};
    }
  }
  /* :focus-visible en vez de :focus — al tocar una opción el <li tabIndex=0>
     se queda enfocado y el fondo lila persistía como si fuera la elegida.
     Con focus-visible el resaltado se reserva a la navegación por teclado. */
  &:focus {
    outline: none;
  }
  &:focus-visible {
    background-color: ${({ theme }) =>
      theme.colors.backgroundLila}; /* CAMBIO: Color lila ROIS para focus */
    font-weight: ${({ theme }) => theme.fontWeight.medium};
    outline: none;
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;
